module.exports = __webpack_public_path__ + "img/chart@2x.b7eb4b80.webp";